// extracted by mini-css-extract-plugin
export default {"departments":"aH-z","departmentHeading":"bH-z","departmentSection":"cH-z","departmentName":"dH-z","departmentLink":"eH-z","expandIcon":"fH-z"};